export enum NotificationType {
  ActiveVisit,
}
